import { FilledType, HistoricalOrderType, OrderType } from 'data/Order/types'

import { HistoricalActionType } from './actions'
import * as AT from './actionTypes'
import positionsReducer, {
  initialState as positionsInitialState,
  PositionsState
} from './positions/slice'
import { TransferType } from './types'

export type HistoricalStateType = {
  canLoadMore: boolean
  currentOrder?: OrderType
  filledOrders: Array<OrderType>
  filledTrades: Array<FilledType>
  isLoadingOrders: boolean
  isLoadingTrades: boolean
  lookback: number
  orders?: Array<HistoricalOrderType>
  positions: PositionsState
  transfers?: Array<TransferType>
}

const initialState: HistoricalStateType = Object.freeze({
  canLoadMore: false,
  filledOrders: [],
  filledTrades: [],
  isLoadingOrders: false,
  isLoadingTrades: false,
  lookback: 1,
  positions: positionsInitialState
})

const historical = (
  oldState: HistoricalStateType = initialState,
  action: HistoricalActionType
): HistoricalStateType => {
  const state = {
    ...oldState,
    positions: positionsReducer(oldState.positions, action)
  }

  switch (action.type) {
    case AT.SET_CAN_LOAD_MORE: {
      return {
        ...state,
        canLoadMore: action.payload.status
      }
    }

    case AT.SET_IS_LOADING_ORDERS: {
      return {
        ...state,
        isLoadingOrders: action.payload.status
      }
    }

    case AT.SET_IS_LOADING_TRADES: {
      return {
        ...state,
        isLoadingTrades: action.payload.status
      }
    }

    case AT.SET_ORDERS: {
      return {
        ...state,
        orders: action.payload.orders
      }
    }

    case AT.SET_FILLED_ORDERS: {
      return {
        ...state,
        filledOrders: action.payload.filledOrders
      }
    }

    case AT.SET_ORDER_DETAIL: {
      return {
        ...state,
        currentOrder: action.payload.order
      }
    }

    case AT.SET_TRANSFERS: {
      return {
        ...state,
        transfers: action.payload.transfers
      }
    }

    case AT.SET_FILLED_TRADES: {
      return {
        ...state,
        filledTrades: action.payload.filledTrades
      }
    }

    case AT.SET_LOOKBACK: {
      return {
        ...state,
        lookback: action.payload.lookback
      }
    }

    default:
      return state
  }
}

export default historical
